export const SHOP_TYPE = {
  STORE: 'store',
  RESTAURANT: 'restaurant'
}

export const SUPPORT_TICKET_STATUS = {
  OPEN: 'open',
  IN_PROGRESS: 'inProgress',
  CLOSED: 'closed'
}
